import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { PropertyResponseSchema } from "../response/PropertyResponse";

const useGetProperty = (id: string) => {
    return useQuery({
        queryKey: ['property', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/property/${id}`);

                // Validasi response
                const validationResult = PropertyResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid property data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch property with ID: ${id}`, error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useGetProperty;